import React from "react";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const Modal = React.memo(
  ({
    isOpen,
    handleClose,
    textButton1,
    textButton2,
    textContent,
    actionFunction1,
    actionFunction2,
    isDisabled,
    children
  }) => {
    const classes = useStyles();
    return (
      <div>
        <Dialog
          open={isOpen}
          transition={Transition}
          keepMounted
          aria-labelledby="responsive-slide-title"
          aria-describedby="responsive-slide-description"
          classes={{
            root: classes.modalRoot,
            paper: classes.modalBody
          }}
        >
          <DialogTitle
            id="responsive-dialog-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={handleClose}
            >
              <Close className={classes.modalClose} />
            </Button>
          </DialogTitle>
          <DialogContent>
            <p className={classes.textContent}> {textContent} </p>
            {children}
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            {actionFunction1 && (
              <Button onClick={actionFunction1} color="danger">
                {textButton2}
              </Button>
            )}
            {actionFunction2 && (
              <Button
                disabled={isDisabled}
                onClick={actionFunction2}
                color="info"
              >
                {" "}
                {textButton1}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);
